import { Link } from "react-router-dom";
import { categories } from "@/mocks/novels";

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-6">
          分类浏览
        </h2>
        <div className="flex items-center justify-center flex-wrap gap-2">
          {categories.map((cat) => {
            const isActive =
              activeCategory === cat.slug ||
              (activeCategory === "" && cat.slug === "全部");
            return (
              <button
                key={cat.slug}
                onClick={() => onCategoryChange(cat.slug === "全部" ? "" : cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                  isActive
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                <i className={`${cat.icon} text-sm`}></i>
                {cat.name}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}